import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const SmsApiForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const initialValues = {
    apiname: props.data ? props.data.Apiname : "",
  };

  const validationSchema = yup.object().shape({
    apiname: yup.string().required("Api Name required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { apiname } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, apiname }
      : { apiname };

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateSmsApi" : "createSmsApi",
      variables,
      mutationObjectName: "functionParams",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "SMS API",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Sms Api" : "Create Sms Api"}
        subtitle={
          props.isEditing ? "Edit an Existing Sms Api" : "Create a New Sms Api"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Api Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.apiname}
                name="apiname"
                error={touched.apiname && !!errors.apiname}
                helperText={touched.apiname && errors.apiname}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default SmsApiForm;
